import { Box, useTheme } from '@mui/material'
import { AppLogo } from 'components'
import { useNavigate } from 'react-router-dom'

export const TopbarNavLeftSide = (): JSX.Element => {
  const { customColors } = useTheme()
  const navigate = useNavigate()
  return (
        <Box
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: customColors.colorHover
              }
            }}
            onClick={() => { navigate('/') }}
        >
            <AppLogo />
        </Box>
  )
}
